const aboutContent = {
  about: `About`,
  leadership: [
    {
      fields: {
        name: `Allan Jones`,
        role: `CEO + Founder`,
        biography: `Allan is the CEO and Founder of Bambee, a company focused on solving complex HR problems for small businesses. He founded Bambee under the premise that every business in America, no matter how big or how small, should have access to an affordable, dedicated HR Manager. A 2X founder, his background includes working directly with small businesses as the Chief Marketing Officer at ZipRecruiter and also includes time as the Head of Product at Docstoc (acquired by Intuit). Allan is passionate about finding creative solutions to complex problems through product. Specifically, Allan is focused on delivering employment equity to the market by building products that remove friction in the workplace. He believes that technology must focus on enabling more people at work access to critical HR infrastructure.`,
        skills: [
          `Product`,
          `SMB`,
          `Marketing`,
          `HR`
        ],
        image: {
          assetId: `wT1f30qiggaWwTOmJuZoB`,
          url: `/assets/cms/wT1f30qiggaWwTOmJuZoB.png`,
          title: `Allan Jones`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Lainie Cooney`,
        role: `Chief People Officer`,
        biography: `An industry recognized HR business partner with over 25 years of experience in all functional areas. Extensive success in the comprehensive leadership of larger human resource organizations. Exceptional communication skills with superlative written, oral and interpersonal talents. Able to drive results within highly matrixed, geographically dispersed organizations.`,
        skills: [
          `Executive HR Leadership`,
          `Human Resources Strategy & Development`,
          `Mergers & Acquisitions`,
          `Compensation & Benefits`
        ],
        image: {
          assetId: `3aT1fFkEBTbr131JmEcbct`,
          url: `/assets/cms/3aT1fFkEBTbr131JmEcbct.jpg`,
          title: `Lainie Cooney`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Mike Ruangutai`,
        role: `Chief Technology Officer`,
        biography: `As the former VP of Product Development at ADP, Mike led a global team responsible for tax, payment, and compliance products powering over 700,000 US companies large and small. He brings over 20 years of technology experience having led product development teams in the media, video gaming, and healthcare SaaS product spaces.`,
        skills: [
          `Technology`,
          `Infrastructure`,
          `Strategy`,
          `Leadership`,
          `Data Security`
        ],
        image: {
          assetId: `Mv9ZcdRZGgk4zdYeoSqBA`,
          url: `/assets/cms/Mv9ZcdRZGgk4zdYeoSqBA.png`,
          title: `mike-ruangutai`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Steven Gross`,
        role: `Chief Financial Officer`,
        biography: `Previously at Rent.com, Headspace, Pollen, and StackCommerce, Steven is an experienced finance and strategy executive. He has a proven track record of building companies, raising venture capital, and scaling hyper-growth tech companies.`,
        skills: [
          `Finance`,
          `Strategy`,
          `Analytics`,
          `Leadership`,
          `Scaleups`
        ],
        image: {
          assetId: `7zekbQ3iNDK50zDkD3xUmO`,
          url: `/assets/cms/7zekbQ3iNDK50zDkD3xUmO.png`,
          title: `Steven Gross`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Matt Goldsmith`,
        role: `Chief Customer Officer`,
        biography: `Previously in corporate HR at Macy’s and Target, Matt has launched and led multiple teams at Bambee, including the HR Account Management and Sales functions. He has a proven track record of scaling new teams and business functions across multiple business units.`,
        skills: [
          `Strategy`,
          `Leadership`,
          `Operations`,
          `HR`
        ],
        image: {
          assetId: `5uxpUWpf1yhnkMzDFXOGzf`,
          url: `/assets/cms/5uxpUWpf1yhnkMzDFXOGzf.png`,
          title: `Matt Goldsmith`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Paul Sternhell`,
        role: `Chief Operating Officer`,
        biography: `Previously at OpenX, Google, Samsung, and GE, Paul is an operations and product executive with over 25 years of experience leading global and geographically distributed teams in technology software and hardware. He was formerly Chief Customer Officer and Chief Product Officer at Bambee. Paul has an MBA from Harvard Business School and a BS in Industrial Engineering from the University of Illinois.`,
        skills: [
          `Operations`,
          `Product`,
          `Sales`,
          `Strategy`,
          `Leadership`
        ],
        image: {
          assetId: `NQjQWiwOoInEQjWKMjEwB`,
          url: `/assets/cms/NQjQWiwOoInEQjWKMjEwB.png`,
          title: `Paul Sternhell`,
          description: null,
        }
      }
    }
  ],
  team: [
    {
      fields: {
        name: `Leon Tchikindas`,
        role: `SVP, Product & Data`,
        image: {
          assetId: `34r9PnbrGLCz9xHlGbDzwg`,
          url: `/assets/cms/34r9PnbrGLCz9xHlGbDzwg.png`,
          title: `Leon Tchikindas`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `James Lee`,
        role: `VP, Platform Services`,
        image: {
          assetId: `3ehE7HFjIqaWlXfbuIAszr`,
          url: `/assets/cms/3ehE7HFjIqaWlXfbuIAszr.png`,
          title: `James Lee`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `David Chau`,
        role: `VP, Marketing`,
        image: {
          assetId: `1vkGOKbpRozh6AKcLz8mSU`,
          url: `/assets/cms/1vkGOKbpRozh6AKcLz8mSU.png`,
          title: `david-chau`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Mark Doody`,
        role: `VP, Sales`,
        image: {
          assetId: `4UPXguky0Y9kxsJRojtBME`,
          url: `/assets/cms/4UPXguky0Y9kxsJRojtBME.png`,
          title: `Mark Doody-`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Diana `,
        role: `Manager, Key Accounts`,
        image: {
          assetId: `2HbGz0ibzQmsmtpnwQB6To`,
          url: `/assets/cms/2HbGz0ibzQmsmtpnwQB6To.jpg`,
          title: `diana-de-la-Torre`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Claudia `,
        role: `Director, Operations`,
        image: {
          assetId: `3rPEWMbQhBQoCHxuFiHZNJ`,
          url: `/assets/cms/3rPEWMbQhBQoCHxuFiHZNJ.jpg`,
          title: `claudia-jaimes`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Phil`,
        role: `Manager, Inside Sales`,
        image: {
          assetId: `3l3q0zRG57fLdU7SKEgZQZ`,
          url: `/assets/cms/3l3q0zRG57fLdU7SKEgZQZ.jpg`,
          title: `phil-hahn`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Joey `,
        role: `Director, Sales`,
        image: {
          assetId: `467MPJt1YoW0gWdnk3Erxv`,
          url: `/assets/cms/467MPJt1YoW0gWdnk3Erxv.jpg`,
          title: `joey-joyce`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Brady `,
        role: `Manager, Account Management`,
        image: {
          assetId: `3RquVGEk9tfgaKwlqny1bE`,
          url: `/assets/cms/3RquVGEk9tfgaKwlqny1bE.jpg`,
          title: `brady-murphy-new`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Matthew `,
        role: `Principal Software Engineer, Platform`,
        image: {
          assetId: `7JeeudH5B0qi10zDrOqh9p`,
          url: `/assets/cms/7JeeudH5B0qi10zDrOqh9p.jpg`,
          title: `matt-schnee`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Danette `,
        role: `Manager, Customer Success`,
        image: {
          assetId: `2UHxbsPxPUSg9OTNHVY1c8`,
          url: `/assets/cms/2UHxbsPxPUSg9OTNHVY1c8.jpg`,
          title: `danette-fuentes`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Anna `,
        role: `Manager, Operations`,
        image: {
          assetId: `7nN4IdE14K45DYCWD4dQ6q`,
          url: `/assets/cms/7nN4IdE14K45DYCWD4dQ6q.jpg`,
          title: `Anna Trumbo`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Ashley `,
        role: `Sales Account Executive`,
        image: {
          assetId: `TUHa7FUUsJ6wU4OdnXvI1`,
          url: `/assets/cms/TUHa7FUUsJ6wU4OdnXvI1.png`,
          title: `Ashley Anaya`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Shelley `,
        role: `Strategic Sales Account Executive`,
        image: {
          assetId: `1lgtuiJcqyTusv6TCuPXf1`,
          url: `/assets/cms/1lgtuiJcqyTusv6TCuPXf1.png`,
          title: `Shelley Rolph`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Kevin `,
        role: `HR Compliance Manager`,
        image: {
          assetId: `54IaJlGBFDFLmAO7SzSiPF`,
          url: `/assets/cms/54IaJlGBFDFLmAO7SzSiPF.png`,
          title: `Kevin Monk`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Christina `,
        role: `Director, Lifecycle Marketing`,
        image: {
          assetId: `3Q97qkXBXxQLviXLWFZFzc`,
          url: `/assets/cms/3Q97qkXBXxQLviXLWFZFzc.png`,
          title: `Christina Savinar`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Adam `,
        role: `Engineering Manager`,
        image: {
          assetId: `Oj6KdXteyfxrLREwez5M5`,
          url: `/assets/cms/Oj6KdXteyfxrLREwez5M5.png`,
          title: `Adam Lane`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Cynthia `,
        role: `Recruiter`,
        image: {
          assetId: `4ZI9lXl9imGKMjjf5abXHu`,
          url: `/assets/cms/4ZI9lXl9imGKMjjf5abXHu.png`,
          title: `Cynthia Fiscus`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Trace `,
        role: `Sr. Software Engineer, Back End`,
        image: {
          assetId: `6BAoOQrAT3RGjBECmApuMr`,
          url: `/assets/cms/6BAoOQrAT3RGjBECmApuMr.png`,
          title: `Trace Ohrt`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Future `,
        role: `HR Account Manager, Key Accounts`,
        image: {
          assetId: `6wA8tjmrPt1SaGO7NvpdZl`,
          url: `/assets/cms/6wA8tjmrPt1SaGO7NvpdZl.png`,
          title: `Future Smith`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Natalie `,
        role: `Sr. Associate HR Account Manager`,
        image: {
          assetId: `2PHvfKXE4gJAVwRtjHJdH8`,
          url: `/assets/cms/2PHvfKXE4gJAVwRtjHJdH8.png`,
          title: `Natalie Needs`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Halima `,
        role: `Director, Customer Success`,
        image: {
          assetId: `1gImAyCrM7Z6pOhJq04auj`,
          url: `/assets/cms/1gImAyCrM7Z6pOhJq04auj.jpg`,
          title: `Halima Muhammad`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Brian `,
        role: `Director, Finance`,
        image: {
          assetId: `mn4mPFGGM5WFR2MZ3e2Vu`,
          url: `/assets/cms/mn4mPFGGM5WFR2MZ3e2Vu.png`,
          title: `Brian Zimring`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Tommy `,
        role: `Director, Engineering`,
        image: {
          assetId: `5sW0Pedo0v2omDYf4pow98`,
          url: `/assets/cms/5sW0Pedo0v2omDYf4pow98.jpg`,
          title: `Tommy Coppers`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Ava`,
        role: `Sales Account Executive`,
        image: {
          assetId: `6ELnKPC0BgjtqV5JSIlq56`,
          url: `/assets/cms/6ELnKPC0BgjtqV5JSIlq56.png`,
          title: `Ava Varelas`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Megan `,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `1zXO6L3vzWgthSXuDdRjbE`,
          url: `/assets/cms/1zXO6L3vzWgthSXuDdRjbE.png`,
          title: `Megan Winters`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Yanique `,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `6bdYm9ah8vHtSrAGe4C2iT`,
          url: `/assets/cms/6bdYm9ah8vHtSrAGe4C2iT.png`,
          title: `Yanique Salmon`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Connie `,
        role: `Senior Implementation Specialist`,
        image: {
          assetId: `1CG9Pz7Csxdzob1K0LFgSR`,
          url: `/assets/cms/1CG9Pz7Csxdzob1K0LFgSR.png`,
          title: `Connie Ciprian`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Vanessa `,
        role: `Sr. Strategic Sales Account Executive`,
        image: {
          assetId: `1Mh4yspW6ujbm0Ky3QnEcw`,
          url: `/assets/cms/1Mh4yspW6ujbm0Ky3QnEcw.png`,
          title: `Vanessa Mitilier`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Sierra `,
        role: `Sr. HR Business Partner`,
        image: {
          assetId: `5rVIaaakcWiOkF1Xtrp5bD`,
          url: `/assets/cms/5rVIaaakcWiOkF1Xtrp5bD.png`,
          title: `Sierra Strohson`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Seth `,
        role: `Sr. Software Engineer, Dev Ops`,
        image: {
          assetId: `U1QivVspFpnaQNzbjlBNt`,
          url: `/assets/cms/U1QivVspFpnaQNzbjlBNt.png`,
          title: `Seth Alexander`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Daniel `,
        role: `Principal Software Engineer, Front End`,
        image: {
          assetId: `4MWhrKz6n9LhVtYmf1vp8I`,
          url: `/assets/cms/4MWhrKz6n9LhVtYmf1vp8I.png`,
          title: `Daniel Cress`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Honey `,
        role: `Jr. Account Executive`,
        image: {
          assetId: `2nCtu26KEdjLrrrzpRUiu2`,
          url: `/assets/cms/2nCtu26KEdjLrrrzpRUiu2.png`,
          title: `Honey Shively`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Zephyr `,
        role: `Executive Assistant`,
        image: {
          assetId: `IFto3PDAsPm08Go4aDA40`,
          url: `/assets/cms/IFto3PDAsPm08Go4aDA40.png`,
          title: `Zephyr Lee`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Troy `,
        role: `Controller`,
        image: {
          assetId: `7qZJ8jspqYdv0gDnoteYQk`,
          url: `/assets/cms/7qZJ8jspqYdv0gDnoteYQk.png`,
          title: `Troy Taitano `,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Brittany `,
        role: `HR Account Manager`,
        image: {
          assetId: `1Qggh6whq1kzORoxOk1WPH`,
          url: `/assets/cms/1Qggh6whq1kzORoxOk1WPH.png`,
          title: `Brittany Gunnink (2)`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Julia `,
        role: `HR Account Manager`,
        image: {
          assetId: `2AtMao7Cu694UGSAbwU6Wh`,
          url: `/assets/cms/2AtMao7Cu694UGSAbwU6Wh.png`,
          title: `Julia Gipson (2)`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Melissa `,
        role: `HR Compliance Specialist`,
        image: {
          assetId: `58TGKlI7CM8SK4BxIKBDBD`,
          url: `/assets/cms/58TGKlI7CM8SK4BxIKBDBD.png`,
          title: `Melissa Bailey `,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Rachel`,
        role: `HR Business Partner`,
        image: {
          assetId: `2ZQnNCDFTEYzBb2XwwmRuc`,
          url: `/assets/cms/2ZQnNCDFTEYzBb2XwwmRuc.png`,
          title: `HR Account Manager`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Chris`,
        role: `Director, Data`,
        image: {
          assetId: `4P5zdY0YYo3Kb1T0ok0QhP`,
          url: `/assets/cms/4P5zdY0YYo3Kb1T0ok0QhP.png`,
          title: `Sr. Analytica Engineering Manager`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Seva`,
        role: `Lead Salesforce Developer`,
        image: {
          assetId: `7cDv4v1RBZ9IiDdoSYarmX`,
          url: `/assets/cms/7cDv4v1RBZ9IiDdoSYarmX.png`,
          title: `Senior Salesforce Developer`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Phillip`,
        role: `Senior Product Designer `,
        image: {
          assetId: `1YalWH7owKXvfuUOE9GiXq`,
          url: `/assets/cms/1YalWH7owKXvfuUOE9GiXq.png`,
          title: `Senior Product Designer `,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Margarita`,
        role: `HR Specialist, Phone Support`,
        image: {
          assetId: `2ZG410Oono3yONygNQiE1L`,
          url: `/assets/cms/2ZG410Oono3yONygNQiE1L.png`,
          title: `Customer Success Specialist`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Dennis`,
        role: `Software Engineer, Front End`,
        image: {
          assetId: `44qAQRfv51X8NFBOcqCaox`,
          url: `/assets/cms/44qAQRfv51X8NFBOcqCaox.png`,
          title: `Principle Front End Engineer`,
          description: null,
        }
      }
    },
    {
      fields: {
        name: `Joseph`,
        role: `Account Executive, Payroll`,
        image: {
          assetId: `1vypn5PqvTcklH7KrBHo6j`,
          url: `/assets/cms/1vypn5PqvTcklH7KrBHo6j.jpg`,
          title: `Sales Development Representative, Payroll`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Yvette`,
        role: `HR Account Manager`,
        image: {
          assetId: `1V2lbEycoxgYqMGOeCCP7u`,
          url: `/assets/cms/1V2lbEycoxgYqMGOeCCP7u.png`,
          title: `Yvette Heredia`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Gipsy`,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `7Ehyo3K7OUAmvdJH2WIHbS`,
          url: `/assets/cms/7Ehyo3K7OUAmvdJH2WIHbS.png`,
          title: `Gipsy Ramirez`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Dean`,
        role: `Software Engineer, Test`,
        image: {
          assetId: `2Qy5tRlaJ0fBRmMSCWu4y0`,
          url: `/assets/cms/2Qy5tRlaJ0fBRmMSCWu4y0.png`,
          title: `Dean Smith`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Sheryl`,
        role: `Associate HR Account Manager`,
        image: {
          assetId: `NOqh68LrEcrRx8Oqr06wO`,
          url: `/assets/cms/NOqh68LrEcrRx8Oqr06wO.png`,
          title: `Sheryl Davis`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Soledad`,
        role: `Manager, HR Accounts`,
        image: {
          assetId: `UiJcSorRaYqGNm58SKpdP`,
          url: `/assets/cms/UiJcSorRaYqGNm58SKpdP.png`,
          title: `Soledad Lujan`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Roshunda`,
        role: `Implementation Specialist, Payroll`,
        image: {
          assetId: `89DEACgCg9ENWoMD43Xff`,
          url: `/assets/cms/89DEACgCg9ENWoMD43Xff.jpg`,
          title: `Roshunda Willis`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Juan`,
        role: `Account Executive`,
        image: {
          assetId: `3OnYJvbCKZxHjw47qOEWlQ`,
          url: `/assets/cms/3OnYJvbCKZxHjw47qOEWlQ.jpg`,
          title: `Juan Bobe`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Diana`,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `3uoGDYe9Ilh0ORvGd4V0dR`,
          url: `/assets/cms/3uoGDYe9Ilh0ORvGd4V0dR.png`,
          title: `Diana Dix`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Elizabeth`,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `3T75Aganza4aq5mfnvqB0I`,
          url: `/assets/cms/3T75Aganza4aq5mfnvqB0I.png`,
          title: `Elizabeth Jose Esteves`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jackelyn`,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `7EpgOakz1g057hBtGnEOI3`,
          url: `/assets/cms/7EpgOakz1g057hBtGnEOI3.jpg`,
          title: `Jackelyn Segura`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Candas`,
        role: `HR Specialist, Phone Support`,
        image: {
          assetId: `2Ei95Hbd7DfxqI6nMoHdYt`,
          url: `/assets/cms/2Ei95Hbd7DfxqI6nMoHdYt.jpg`,
          title: `Candas Crutcher`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Crystal`,
        role: `HR Specialist, Phone Support`,
        image: {
          assetId: `38fxhav2kAofqkzI5uehrr`,
          url: `/assets/cms/38fxhav2kAofqkzI5uehrr.jpg`,
          title: `Crystal Carranza`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jocelyne`,
        role: `HR Specialist, Phone Support`,
        image: {
          assetId: `2CwqGWD2J9t8PKiwqoYfQS`,
          url: `/assets/cms/2CwqGWD2J9t8PKiwqoYfQS.png`,
          title: `Jocelyne Lopez`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Christian`,
        role: `Office Manager & IT Support`,
        image: {
          assetId: `4K96ODLibFt7i61ppASOqm`,
          url: `/assets/cms/4K96ODLibFt7i61ppASOqm.jpg`,
          title: `Christian Friesing`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jenny`,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `7zsTXYrHSiKwqfuUiY3587`,
          url: `/assets/cms/7zsTXYrHSiKwqfuUiY3587.jpg`,
          title: `Jenny Herrington`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Laurina`,
        role: `Account Coordinator`,
        image: {
          assetId: `QhvdOcOGxjuo11yF6Rrz8`,
          url: `/assets/cms/QhvdOcOGxjuo11yF6Rrz8.jpg`,
          title: `Laurina Chavez`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `John`,
        role: `Sr. Manager, Operations`,
        image: {
          assetId: `H84DjD2USMhGtODoIdPQt`,
          url: `/assets/cms/H84DjD2USMhGtODoIdPQt.jpg`,
          title: `John Yu`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Weslley`,
        role: `Sr. Software Engineer, Full Stack`,
        image: {
          assetId: `2LMprRvrM288BkgnhepqMN`,
          url: `/assets/cms/2LMprRvrM288BkgnhepqMN.jpg`,
          title: `Weslley Braga`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `EJ`,
        role: `Customer Support Specialist`,
        image: {
          assetId: `1caZdKK0RmUaF4e02dvpjV`,
          url: `/assets/cms/1caZdKK0RmUaF4e02dvpjV.jpg`,
          title: `EJ Serafin`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Annalise`,
        role: `HR Account Manager, Key Accounts`,
        image: {
          assetId: `7GobDXTPAcNNsyTNwrWJdu`,
          url: `/assets/cms/7GobDXTPAcNNsyTNwrWJdu.jpg`,
          title: `Anna Lise Gorden`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Brad`,
        role: `HR Business Partner`,
        image: {
          assetId: `2NTTBGZi30EcvyONeem8Td`,
          url: `/assets/cms/2NTTBGZi30EcvyONeem8Td.jpg`,
          title: `Brad Harper`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Alexander`,
        role: `Software Engineer, Full Stack`,
        image: {
          assetId: `3rEnb7lVHU6sdSImmyd3dE`,
          url: `/assets/cms/3rEnb7lVHU6sdSImmyd3dE.jpg`,
          title: `Alexander Hamilton`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Ali`,
        role: `Customer Support Specialist`,
        image: {
          assetId: `5VYMaZaE8mFyQATmi3asbS`,
          url: `/assets/cms/5VYMaZaE8mFyQATmi3asbS.png`,
          title: `Ali McCarthy`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Osvaldo`,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `6p9yBkb8JhehAOeyiGQL3f`,
          url: `/assets/cms/6p9yBkb8JhehAOeyiGQL3f.png`,
          title: `Osvaldo Jaime`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Dominic`,
        role: `Manager, Learning & Development`,
        image: {
          assetId: `6aXUX6WWCHKoUQlJgpjsfm`,
          url: `/assets/cms/6aXUX6WWCHKoUQlJgpjsfm.png`,
          title: `Dominic Le Fort`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Alicia`,
        role: `Sales Operations Manager`,
        image: {
          assetId: `65RKKMT4QaFWcY6dP1frXc`,
          url: `/assets/cms/65RKKMT4QaFWcY6dP1frXc.jpg`,
          title: `Alicia Aguilera`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Sandy`,
        role: `HR Account Manager, SMB`,
        image: {
          assetId: `jDK5pcXKSbHXM6wI11vJd`,
          url: `/assets/cms/jDK5pcXKSbHXM6wI11vJd.png`,
          title: `Sandy Bone`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Brent`,
        role: `Staff Accountant`,
        image: {
          assetId: `13xvr6IeeyjAgnolD71lR0`,
          url: `/assets/cms/13xvr6IeeyjAgnolD71lR0.jpg`,
          title: `Brent Landaverde`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Andrew`,
        role: `Strategic Account Executive`,
        image: {
          assetId: `2vbh707DcGT1YaEe4O4lR1`,
          url: `/assets/cms/2vbh707DcGT1YaEe4O4lR1.png`,
          title: `Andrew Tree`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Victoria`,
        role: `Sales Development Representative`,
        image: {
          assetId: `6R9PMnzPFSWzLmm1eu0dqT`,
          url: `/assets/cms/6R9PMnzPFSWzLmm1eu0dqT.png`,
          title: `Victoria Peterson`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Christian`,
        role: `Software Engineer, Front End`,
        image: {
          assetId: `5YopiAvPNEVw432Y3K7eA8`,
          url: `/assets/cms/5YopiAvPNEVw432Y3K7eA8.png`,
          title: `Christian Lance`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Isaac`,
        role: `Sr. Software Engineer, Front End`,
        image: {
          assetId: `4xNTlVXbq5uotUxHBHG9vB`,
          url: `/assets/cms/4xNTlVXbq5uotUxHBHG9vB.png`,
          title: `Isaac Weber`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Robert`,
        role: `Sr. Software Engineer, Back End`,
        image: {
          assetId: `nynCLUM28cWHrkLxf8kNf`,
          url: `/assets/cms/nynCLUM28cWHrkLxf8kNf.png`,
          title: `Robert Kraig, Sr Engineer`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Nick`,
        role: `Account Executive`,
        image: {
          assetId: `6DquLy2J8p2VmWPaRT9JsZ`,
          url: `/assets/cms/6DquLy2J8p2VmWPaRT9JsZ.png`,
          title: `Nick Griffith`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jennifer`,
        role: `Executive Assistant`,
        image: {
          assetId: `tvaqBqpJpbizMcyPgM78i`,
          url: `/assets/cms/tvaqBqpJpbizMcyPgM78i.png`,
          title: `Jenn Davis`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jess`,
        role: `Human Resources Manager - Corporate`,
        image: {
          assetId: `6WavlImjQ4xLIaTAXSVCJ4`,
          url: `/assets/cms/6WavlImjQ4xLIaTAXSVCJ4.png`,
          title: `Jesse Gil`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Roxsanne`,
        role: `Implementation Specialist, Payroll`,
        image: {
          assetId: `3ikUzuMqcpZGA7NI7RpOsJ`,
          url: `/assets/cms/3ikUzuMqcpZGA7NI7RpOsJ.png`,
          title: `Roxsanne Preciado`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Tanya`,
        role: `HR Account Manager`,
        image: {
          assetId: `2OgIT6ZjNgPGwQjaGfVGwI`,
          url: `/assets/cms/2OgIT6ZjNgPGwQjaGfVGwI.png`,
          title: `Tanya Francio`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Michael`,
        role: `Customer Support Specialist`,
        image: {
          assetId: `4eMIDyfGXdnwWAHaAVMfMa`,
          url: `/assets/cms/4eMIDyfGXdnwWAHaAVMfMa.png`,
          title: `Michael Kurzer, CSS`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Michelle`,
        role: `Learning & Development Specialist`,
        image: {
          assetId: `6lYFfjcT62StJFgndWQHB4`,
          url: `/assets/cms/6lYFfjcT62StJFgndWQHB4.jpg`,
          title: `Michelle Bukirin, L&D`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Laramie`,
        role: `Customer Activation Specialist`,
        image: {
          assetId: `3ES4S4S10oXyJmRiLVXyLc`,
          url: `/assets/cms/3ES4S4S10oXyJmRiLVXyLc.png`,
          title: `Laramie Davitian, Cust Activ Spclst`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Catherine`,
        role: `HR Specialist`,
        image: {
          assetId: `7dFEEK471HeGWCRM1PeZla`,
          url: `/assets/cms/7dFEEK471HeGWCRM1PeZla.png`,
          title: `Catherine Gibbs, HR Spclst`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Vianey`,
        role: `Sales Development Representative, Payroll`,
        image: {
          assetId: `3NwFxGnSZVFqBpUbOdt2MP`,
          url: `/assets/cms/3NwFxGnSZVFqBpUbOdt2MP.png`,
          title: `Vianey Hernandez, Payroll SDR`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jack`,
        role: `Staff Software Engineer, Dev Ops`,
        image: {
          assetId: `7qnHFhSeLXqRZCkoaPHo5r`,
          url: `/assets/cms/7qnHFhSeLXqRZCkoaPHo5r.png`,
          title: `Jack`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Brian`,
        role: `Accounting Manager`,
        image: {
          assetId: `75l61Rjw7jyaafEix0t4T6`,
          url: `/assets/cms/75l61Rjw7jyaafEix0t4T6.jpeg`,
          title: `Brian Sung`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Rachel`,
        role: `Customer Support Specialist, Payroll`,
        image: {
          assetId: `3b7qOm1fRWanRpekJqOMwC`,
          url: `/assets/cms/3b7qOm1fRWanRpekJqOMwC.jpeg`,
          title: `Rachel Thompson`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Gilberto`,
        role: `Sales Development Representative, Payroll`,
        image: {
          assetId: `aSN2g45HcbHJ6mTSB33yf`,
          url: `/assets/cms/aSN2g45HcbHJ6mTSB33yf.jpeg`,
          title: `Gilbert Gonzales`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Matthew`,
        role: `Head of Strategic Partnerships`,
        image: {
          assetId: `3Fd1fTpPRx2YmhjXWyhuts`,
          url: `/assets/cms/3Fd1fTpPRx2YmhjXWyhuts.jpg`,
          title: `Matt Withers`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Marlene`,
        role: `HR Account Manager, Key Accounts`,
        image: {
          assetId: `4QUbUUyZ35635NWTrA49Is`,
          url: `/assets/cms/4QUbUUyZ35635NWTrA49Is.png`,
          title: `Marlene Cardenas`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Faith`,
        role: `QA Lead (Call/Chat Quality Assurance)`,
        image: {
          assetId: `7tzWC2RvjyriAlV6N1G99h`,
          url: `/assets/cms/7tzWC2RvjyriAlV6N1G99h.png`,
          title: `Faith Del Regno`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Denise`,
        role: `Implementation Specialist, Payroll`,
        image: {
          assetId: `2EJIUcdOxpeXMXnmNizHxQ`,
          url: `/assets/cms/2EJIUcdOxpeXMXnmNizHxQ.png`,
          title: `Denise Long`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jessica`,
        role: `Implementation Specialist, Payroll`,
        image: {
          assetId: `5jtT6fmB30yZZKFb5hV0WT`,
          url: `/assets/cms/5jtT6fmB30yZZKFb5hV0WT.png`,
          title: `Jessica Evans`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Ben`,
        role: `Customer Support Specialist`,
        image: {
          assetId: `61kfk4hZaISNDpAmfHDP9L`,
          url: `/assets/cms/61kfk4hZaISNDpAmfHDP9L.jpg`,
          title: `Ben Paddon`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Conor`,
        role: `Manager, Customer Success`,
        image: {
          assetId: `Qh6sHA8H2hG9enA3pK3Bc`,
          url: `/assets/cms/Qh6sHA8H2hG9enA3pK3Bc.jpg`,
          title: `Conor Jefferies`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Blake `,
        role: `Manager, Inside Sales`,
        image: {
          assetId: `4uNZde6xnnmFV9BQju3WeA`,
          url: `/assets/cms/4uNZde6xnnmFV9BQju3WeA.jpg`,
          title: `Blake Selsor`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jesse`,
        role: `Manager, Customer Success`,
        image: {
          assetId: `3aHFX7QgHQZQtiyMsfHFl3`,
          url: `/assets/cms/3aHFX7QgHQZQtiyMsfHFl3.jpg`,
          title: `Jesse Volk`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Amy`,
        role: `Sr. Strategic Account Executive`,
        image: {
          assetId: `6WFA1SSjZS8JxsxTbfU7WM`,
          url: `/assets/cms/6WFA1SSjZS8JxsxTbfU7WM.jpg`,
          title: `Amy Gimble`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Cecily `,
        role: `Software Engineer, Test`,
        image: {
          assetId: `ocRRUl7nTlZ1fqOYUkUHH`,
          url: `/assets/cms/ocRRUl7nTlZ1fqOYUkUHH.jpg`,
          title: `Cecily Mancini`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Harrison`,
        role: `Senior Email Marketing Manager`,
        image: {
          assetId: `2GTfGIeJvnkx7CFBf7BEZO`,
          url: `/assets/cms/2GTfGIeJvnkx7CFBf7BEZO.jpg`,
          title: `Harrison Woolmington`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Siwei`,
        role: `Product Designer`,
        image: {
          assetId: `VT5B00oaLNqBIypqPfzTz`,
          url: `/assets/cms/VT5B00oaLNqBIypqPfzTz.jpg`,
          title: `Siwei Sun`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Justin`,
        role: `Senior Financial Analyst`,
        image: {
          assetId: `4vRvRyPIGrZjHTOghzyf6q`,
          url: `/assets/cms/4vRvRyPIGrZjHTOghzyf6q.jpg`,
          title: `Justin Kuo`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Stephanie `,
        role: `Vice President, Human Resources`,
        image: {
          assetId: `6tSx4d9JDYQD3NrAQ4dhzM`,
          url: `/assets/cms/6tSx4d9JDYQD3NrAQ4dhzM.jpg`,
          title: `Stephanie Ramos1`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Brittney `,
        role: `Manager, Customer Success`,
        image: {
          assetId: `6yjOf3PawfvhgOWxyIugjf`,
          url: `/assets/cms/6yjOf3PawfvhgOWxyIugjf.jpg`,
          title: `Brittney Friend`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Carlos`,
        role: `Manager, Customer Success`,
        image: {
          assetId: `1JFc2dJizdXa0vAxcv2CAL`,
          url: `/assets/cms/1JFc2dJizdXa0vAxcv2CAL.jpg`,
          title: `Carlos Argueta`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Danny`,
        role: `Marketing Analyst`,
        image: {
          assetId: `1NZWn6Sh8uyAX02oRfNCwH`,
          url: `/assets/cms/1NZWn6Sh8uyAX02oRfNCwH.jpeg`,
          title: `Danny Goldsmith`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Lorenza`,
        role: `Sr. Strategic Sales Account Executive`,
        image: {
          assetId: `p5VxgZq4YdVZoHgTvdV3c`,
          url: `/assets/cms/p5VxgZq4YdVZoHgTvdV3c.jpeg`,
          title: `Lorenza West`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Jacob`,
        role: `Jr. Sales Account Representative`,
        image: {
          assetId: `1DzJV6Z5TwgLoemyUsoR9G`,
          url: `/assets/cms/1DzJV6Z5TwgLoemyUsoR9G.jpeg`,
          title: `Jacob Coronado`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Eli`,
        role: `Account Executive`,
        image: {
          assetId: `7BcBJEYKhpar2ifPaGMz7g`,
          url: `/assets/cms/7BcBJEYKhpar2ifPaGMz7g.jpeg`,
          title: `Eli Rivera Curiel`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Ethan`,
        role: `Account Executive`,
        image: {
          assetId: `11liEWrUvP1OjkKppAhzuA`,
          url: `/assets/cms/11liEWrUvP1OjkKppAhzuA.jpeg`,
          title: `Ethan Jaffe`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Ralph`,
        role: `Account Executive`,
        image: {
          assetId: `4VvghVFpLF39XYRmKnLSv2`,
          url: `/assets/cms/4VvghVFpLF39XYRmKnLSv2.jpeg`,
          title: `Ralph Cortez`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Sina `,
        role: `Director, Product - Automation & Efficiency`,
        image: {
          assetId: `12w0BHlou3S4mRDUZPas6V`,
          url: `/assets/cms/12w0BHlou3S4mRDUZPas6V.jpeg`,
          title: `Sina Basir-Kazeruni2`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Josh`,
        role: `Sales Manager, Existing Business`,
        image: {
          assetId: `4hA8dlr0aCh8UZdXQswrU8`,
          url: `/assets/cms/4hA8dlr0aCh8UZdXQswrU8.jpeg`,
          title: `Josh Woida`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Chase`,
        role: `Strategic Sales Account Executive`,
        image: {
          assetId: `1CX7wJDUIb6TiLnrFoBqpr`,
          url: `/assets/cms/1CX7wJDUIb6TiLnrFoBqpr.jpeg`,
          title: `Chase Conner`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Devin`,
        role: `Account Executive`,
        image: {
          assetId: `2Qk6X6KDk3YM61nBS2UUez`,
          url: `/assets/cms/2Qk6X6KDk3YM61nBS2UUez.jpeg`,
          title: `Devin Joseph`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Kimberlee`,
        role: `Strategic Account Executive`,
        image: {
          assetId: `2WN7s697wNjmxM4RkAxW5N`,
          url: `/assets/cms/2WN7s697wNjmxM4RkAxW5N.jpeg`,
          title: `Kimberlee Barlow`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Nuh`,
        role: `Account Executive, Existing Business`,
        image: {
          assetId: `6q3aNVqd702LkTwDVoVFg6`,
          url: `/assets/cms/6q3aNVqd702LkTwDVoVFg6.jpg`,
          title: `Nuh Alashwal`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Johnathan`,
        role: `Strategic Account Executive, Existing Business`,
        image: {
          assetId: `7rl9SMHTrCy9e4AqykAXzA`,
          url: `/assets/cms/7rl9SMHTrCy9e4AqykAXzA.jpeg`,
          title: `Johnathan Diaz`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Cameron `,
        role: `Account Executive, Existing Business`,
        image: {
          assetId: `x8mBuFS3J5D08cvV1nrjK`,
          url: `/assets/cms/x8mBuFS3J5D08cvV1nrjK.jpg`,
          title: `Cameron Rogers`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Amir `,
        role: `Account Executive, Existing Business`,
        image: {
          assetId: `7kJ4jZLlIUy8alGMLexSst`,
          url: `/assets/cms/7kJ4jZLlIUy8alGMLexSst.jpg`,
          title: `Amir Motearefi`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Aleksandra`,
        role: `Strategic Account Executive, Existing Business`,
        image: {
          assetId: `6NLeh9X6kudJ0KSSEQNa3v`,
          url: `/assets/cms/6NLeh9X6kudJ0KSSEQNa3v.jpg`,
          title: `Aleksandra Vinogradova`,
          description: ``,
        }
      }
    }
  ],
  investors: [
    {
      fields: {
        name: `Alpha Edison`,
        image: {
          assetId: `2Rgos8J2s0ZmznXkUjOktn`,
          url: `/assets/cms/2Rgos8J2s0ZmznXkUjOktn.jpg`,
          title: `Alpha Edison`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `QED`,
        image: {
          assetId: `5ohiBVs2l5I7Hx2OpJ5o7d`,
          url: `/assets/cms/5ohiBVs2l5I7Hx2OpJ5o7d.jpg`,
          title: `QED`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Mucker Capital`,
        image: {
          assetId: `7lzPX8cDs5d3DYe0RbUQ2U`,
          url: `/assets/cms/7lzPX8cDs5d3DYe0RbUQ2U.jpg`,
          title: `Mucker Capital`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Softbank Opportunities Fund`,
        image: {
          assetId: `fCoZn5uEwYfOceXccWj1g`,
          url: `/assets/cms/fCoZn5uEwYfOceXccWj1g.jpg`,
          title: `Softbank`,
          description: ``,
        }
      }
    },
    {
      fields: {
        name: `Greycroft`,
        image: {
          assetId: `7Lfq3AYQzkCa9fCAxJE2dH`,
          url: `/assets/cms/7Lfq3AYQzkCa9fCAxJE2dH.jpg`,
          title: `Greycroft`,
          description: ``,
        }
      }
    }
  ]
} as const;

export default aboutContent;
